import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from 'app/_components/Popover'
import { cx } from 'lib/cx'
import {
  type RenderElementProps,
  useFocused,
  useReadOnly,
  useSelected,
} from 'slate-react'
import { Avatar, Person } from './Person'

export default function Mention({
  element,
  attributes,
  children,
}: RenderElementProps) {
  if (element.type !== 'mention') throw new Error('Unsupported file type')

  const isEditable = !useReadOnly()
  const isSelected = useSelected()
  const isFocused = useFocused()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <span
          className={cx(
            'bg-gray-10 hover:bg-highlight inline-flex cursor-pointer items-center rounded-xl py-1 pr-1.5 pl-1 align-top leading-none',
            isEditable && isSelected && isFocused && 'ring-text-primary ring-2',
          )}
          contentEditable={false}
          {...attributes}
        >
          <Avatar id={element.targetId} />
          <span className="pl-2">
            {element.name}
            {children}
          </span>
        </span>
      </PopoverTrigger>
      <PopoverContent
        className="bg-gray-10 w-full p-1"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <Person id={element.targetId} />
      </PopoverContent>
    </Popover>
  )
}
